import styled from '@emotion/styled';

export const Main = styled.main`
	flex: 1 1 auto;
	background-color: ${p => p.theme.colors.body};
`;
